import env from '@/config/env';
import { CoreEnums } from '@/utils/domain/constants';

/** Admin / SuperAdmin — full tenant administration (incl. `/configuration` menu). */
export const isTenantAdmin = (roles) => {
  const arr = Array.isArray(roles) ? roles : [roles];
  return arr.some((r) => env.USER_ADMIN_ROLES.includes(r ?? ''));
};

/**
 * Staff roles that mirror admin inside module Launchpads (lists, apps,
 * agents, entities) but are blocked from the global `/configuration` menu
 * by route authority. `RoleCollaborator` belongs here.
 */
export const isStaffRole = (roles) => {
  const arr = Array.isArray(roles) ? roles : [roles];
  return isTenantAdmin(arr) || arr.includes(CoreEnums.RoleName.Collaborator);
};

/**
 * Per-item management flag from `/allowed` endpoints (AccessControl vs
 * Collaborator UX guide). Accepts either the normalised tile or its `raw`.
 */
export const itemCanManage = (item) => {
  if (!item) return false;
  if (item.canManage === true) return true;
  if (item.raw?.canManage === true) return true;
  return false;
};
